export type { SelectItemProps } from "@mantine/core";

export * from "./MultiAutocomplete";
